import { render, staticRenderFns } from "./AgentCard.vue?vue&type=template&id=855a04e8&"
import script from "./AgentCard.vue?vue&type=script&lang=ts&"
export * from "./AgentCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports